import React from 'react';
import { Link } from 'react-router-dom';
import { LockOutlined } from '@ant-design/icons';

function UserMenu(props) {    
        return (
            <div className="user-menu-container">
                <Link to="/userProfile" className="gray-icon" style={{display:'flex', alignItems:'center'}}><LockOutlined/>Datos de facturación</Link>
            </div>
        )
    }

export default UserMenu
